import { render, staticRenderFns } from "./RealEstateOfAssetEdit.vue?vue&type=template&id=17566f04&scoped=true&"
import script from "./RealEstateOfAssetEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateOfAssetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17566f04",
  null
  
)

export default component.exports